var audio_rtlignore_default = {
  "fontElementMap": "RP0eP",
  "customPlayer": "nUn3a",
  "customPlayer_basic": "EKj5i",
  "customPlayer_mobile": "av-jd",
  "audio_coverImg": "tfqav",
  "audio_small_cover_image": "_9UyT-",
  "audio_icon_button": "qimuu",
  "audio_contextMenu_wrapper": "_75sx7",
  "customPlayer_with_image": "QhzUT",
  "track_wrapper": "Z5MYl",
  "trackContainer": "tC6NS",
  "audio_download_icon": "-Xbw2",
  "audio_duration": "mvis1",
  "customPlayer_small_fit": "c9B12",
  "track_sliders_wrapper": "_8sqsE",
  "audio_volume_wrapper": "QXzcZ",
  "volume_slider_wrapper": "Ez5GD",
  "audioDetails": "Zdkj6",
  "title": "HDUHK",
  "author_name": "_9BkSd",
  "dropdown_menu_wrapper": "rGh38",
  "dropdown_selected_button": "bPOJ7",
  "dropdown_content": "_131-4",
  "dropdown_content_withIcon": "mTljz",
  "audio_loader_icon": "IMzOa",
  "spin": "OQ98l"
};
export {
  audio_rtlignore_default as default
};
//# sourceMappingURL=audio.rtlignore-scss.js.map
